module.exports = __webpack_public_path__ + "img/alfaclick.c3ca8061.svg";